<h1 class="h3 mb-2 text-gray-800">Resultados de tratamiento</h1>

<div class="card shadow mb-4">
    <div class="card-header py-3">
        <h6 class="m-0 font-weight-bold text-primary">PDF Con los datos de tratamiento</h6>
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col-8">
                <div class="form-group" *ngIf="caso">
                    <label>
                        Presupuesto del caso:
                    </label>
                    <div>
                        <div>{{caso.precio_tratamiento_bs}} Bs</div>
                    </div>
                    <label>
                        PDF del Caso:
                    </label>
                    <div>
                        <a [href]="getFileUrl('pdf-caso')" target="_blank">Ver archivo</a>
                    </div>
                    <div *ngIf="caso.video_entrega">
                        <label>
                            Video de caso:
                        </label>
                        <div>
                            <a href="{{caso.video_entrega}}" target="_blank">
                                <img [src]="getThumbnailUrl(caso.video_entrega)" />
                            </a>
                        </div>
                    </div>

                    <div *ngIf="caso.reunionZoom">
                        <label>
                            Reunión de zoom:
                        </label>
                        <div style="white-space: pre-wrap;">
                            {{caso.reunionZoom}}
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <button type="submit" class="btn btn-success" (click)="aprobar(aprobarModal)">Aprobar
                        caso</button>&nbsp;
                    <button type="submit" class="btn btn-primary" (click)="rechazar(rechazarModal)">Rechazar
                        caso</button>&nbsp;
                    <a [routerLink]="'/casos/'+caso.id+'/verpaciente'" class="btn btn-link">Volver</a>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #rechazarModal let-modal>
    <form name="form" (ngSubmit)="f.form.valid && rechazarResultados()" #f="ngForm">
        <div class="modal-header">
            <h4 class="modal-title" id="modal-basic-title">Rechazar</h4>
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="form-group">
                <label for="dateOfBirth">Motivo de Rechazo</label>
                <textarea [(ngModel)]="caso.motivo_rechazo" #motivoRechazo="ngModel" class="form-control"
                    name="motivoRechazo" [ngClass]="{'is-invalid':  f.submitted && motivoRechazo.invalid}"
                    required></textarea>
                <div *ngIf="f.submitted && motivoRechazo.invalid" class="invalid-feedback">
                    <div *ngIf="motivoRechazo.errors.required">El motivo es requerido</div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="submit" class="btn btn-outline-dark">Confirmar
                Rechazo</button>
        </div>
    </form>
</ng-template>
<ng-template #aprobarModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Aprobar tratamiento</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <app-textoaceptacion></app-textoaceptacion>
    </div>
    <div class="modal-footer">
        <button type="submit" class="btn btn-success" (click)="aprobarResultados()">Confirmar
            Aprobación</button>
        <button type="submit" class="btn btn-danger" (click)="modal.dismiss('Cancel button')">Cancelar</button>
    </div>
</ng-template>